import React from "react";
import styled from "styled-components";

const Products1 = () => {
  return (
    <>
      <Wrapper>
        <div className="product">
          <h2 className="productTitle">Our Products</h2>
          <div className="card-group">
            <div className="card">
              <img
                src={`${process.env.PUBLIC_URL}/mshineP1.png`}
                className="card-img-top"
                alt="D.E.F 5L"
              />
              <div className="card-body">
                <h5 className="card-title">D.E.F</h5>
                <p className="card-text">5 Liter</p>
              </div>
            </div>
            <div className="card">
              <img
                src={`${process.env.PUBLIC_URL}/mshineP2.png`}
                className="card-img-top"
                alt="Radiator Coolant 1L"
              />
              <div className="card-body">
                <h5 className="card-title">Radiator Coolant</h5>
                <p className="card-text">1 Litre</p>
              </div>
            </div>
            <div className="card">
              <img
                src={`${process.env.PUBLIC_URL}/mshineP3.png`}
                className="card-img-top"
                alt="D.E.F 20L"
              />
              <div className="card-body">
                <h5 className="card-title">D.E.F</h5>
                <p className="card-text">20 Liter</p>
              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  text-align: center;
  padding: 2rem;
  /* background-color: #2363e7; */
  background-color: #f7f7f7;

  .productTitle {
    text-transform: uppercase;
    font-family: "Play", sans-serif;
    font-weight: 900;
    font-size: 3rem;
    margin-bottom: 2rem;
    /* color: #00796b; */
    background-color:  #2363e7;
    font-style:italic;
    color: white;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
    
  }

  .card-group {
    display: flex;
    justify-content: center;
    gap: 2rem;
    flex-wrap: wrap;
  }

  .card {
    background-color:  #2363e7;
    margin: 20px;
    /* border-radius: 15px; */
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
    padding: 1rem;
    transition: all 0.3s ease;
    width: 300px;
    text-align: center;

    &:hover {
      /* background-color:rgb(255, 191, 0); */
      /* transform: translateY(-10px); */
      transform: scale(1.1);
      box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
    }

    .card-title {
      font-family: "Inter", sans-serif;
      font-size: 1.5rem;
      font-weight: bold;
      color: #333;
      color: white;
    }

    .card-text {
      font-family: "Inter", sans-serif;
      font-size: 1rem;
      color: #555;
      margin-top: 0.5rem;
      color: white;
    }

    .card-img-top {
      max-width: 100%;
      max-height: 200px;
      object-fit: contain;
      margin-bottom: 1rem;
      padding: 10px;
      border-radius: 10px;
      background-color: #f0f0f0;
    }
  }

  /* Highlight the featured product */
  .featured-product {
    background-color: #e0f7fa;
    box-shadow: 0 8px 16px rgba(0, 123, 255, 0.2);

    &:hover {
      box-shadow: 0 10px 20px rgba(0, 123, 255, 0.3);
    }

    .card-title {
      color: #00796b;
    }
  }

  /* Responsive Styles */
  @media (max-width: 768px) {
    .productTitle {
      font-size: 2rem;
    }

    .card-group {
      flex-direction: column;
      align-items: center;
    }

    .card {
      width: 80%;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .card-group {
      gap: 1rem;
    }

    .card {
      width: 45%;
    }
  }
`;

export default Products1;
